import React from 'react';
import { ArrowRight } from 'lucide-react';
interface CTAButtonProps {
  children: React.ReactNode;
  className?: string;
  fullWidth?: boolean;
  variant?: 'primary' | 'secondary';
  size?: 'default' | 'large';
}
export function CTAButton({
  children,
  className = '',
  fullWidth = false,
  variant = 'primary',
  size = 'default'
}: CTAButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center font-bold transition-all duration-300 rounded-lg shadow-lg hover:shadow-xl transform hover:-translate-y-1 focus:outline-none focus:ring-2 focus:ring-offset-2';
  const variants = {
    primary: 'bg-orange-500 hover:bg-orange-600 text-white focus:ring-orange-500 border-b-4 border-orange-700 active:border-b-0 active:translate-y-0',
    secondary: 'bg-orange-500 hover:bg-orange-600 text-white focus:ring-orange-500 border-b-4 border-orange-700 active:border-b-0 active:translate-y-0'
  };
  const sizes = {
    default: 'px-6 py-3 text-lg',
    large: 'px-8 py-4 text-xl md:text-2xl'
  };
  const widthClass = fullWidth ? 'w-full' : '';
  const scrollToCheckout = (e: React.MouseEvent) => {
    e.preventDefault();
    const checkoutSection = document.getElementById('checkout');
    if (checkoutSection) {
      checkoutSection.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <a href="#checkout" onClick={scrollToCheckout} className={`${baseStyles} ${variants[variant]} ${sizes[size]} ${widthClass} ${className}`} data-id="element-1">
      <span className="mr-2" data-id="element-2">{children}</span>
      <ArrowRight className="w-5 h-5 md:w-6 md:h-6" data-id="element-3" />
    </a>;
}